'use strict';

var dateFns = require('date-fns');

const getIntersectionInterval = (a, b) => {
  if (!dateFns.areIntervalsOverlapping(a, b)) {
    return void 0;
  }
  if (dateFns.isAfter(a.start, b.start) && dateFns.isBefore(a.end, b.end)) {
    return { start: a.start, end: a.end };
  }
  return {
    start: dateFns.max([a.start, b.start]).getTime(),
    end: dateFns.min([a.end, b.end]).getTime()
  };
};

module.exports = getIntersectionInterval;
//# sourceMappingURL=getIntersectionInterval.cjs.map
